export default __webpack_public_path__ + "locales/pl/UploadPanel.json?hash=f6078d71ba9a164d506acea114209c1a";